import Column from '@components/column'
import Banner from './banner'
import Stats from './stats'
import Row from '@components/row'
import NextAppointment from '@commons/cards/nextScheduleAppointment'
import TodayAppointments from './todayAppointments'
import SectionHeading from '@commons/headings/section'
import Tests from './tests'
import Packages from './packages'
import Orders from './orders'
import Tabs from '@commons/tabs'
import Search from '@commons/search'
import Button from '@components/button'
import { useNavigate, useSearchParams } from 'react-router-dom'
import Svg from '@components/svg'
import { InstituteLabTest } from '@apis'
import { useSelector } from 'react-redux'
const InstitutionLabTestsPage = () => {
  const navigate = useNavigate()
  const [searchParams] = useSearchParams()
  const tab = searchParams.get('tab')
  const { data: user } = useSelector((state: any) => state.user)

  const tabs = [
    {
      title: 'Lab Tests',
      key: 'lab-tests',
      Component: Tests,
    },
    {
      title: 'Lab Test Packages',
      key: 'packages',
      Component: Packages,
    },
    {
      title: 'Lab Order',
      key: 'orders',
      Component: Orders,
    },
  ]
  const handleSearchSubmit = async (search) => {
    const params = {
      page: 1,
      limit: 6,
      search: search,
      userId: user?.id,
      isPackage: tab == 'lab-tests' || !tab ? false : true,
    }
    const state =
      tab == 'lab-tests' || !tab
        ? 'instituteLabTests'
        : 'instituteLabTestPackages'
    await InstituteLabTest.list({
      params: params,
      state,
    }).catch(() => {})
  }
  const handleClickCreate = () => {
    switch (tab) {
      case 'lab-tests':
        navigate('/institution/lab-tests/create')
        break
      case 'packages':
        navigate('/institution/lab-packages/create')
        break
      default:
        navigate('/institution/lab-tests/create')
        break
    }
  }
  return (
    <Column rowGap={20}>
      <Stats />
      <Banner />
      <NextAppointment />
      <TodayAppointments />
      <Column rowGap={20}>
        <SectionHeading title="Our Lab Tests" />
        <Tabs
          items={tabs}
          restore={true}
          rightComponent={
            <Row colGap={20}>
              <Search onSubmit={handleSearchSubmit} />
              {(!tab || tab == 'lab-tests' || tab == 'packages') && (
                <Button
                  leftComponent={<Svg svg="circlePlus" color={'white'} />}
                  onClick={handleClickCreate}
                  title={`Create New ${tab == 'lab-tests' || !tab ? 'Lab Test' : 'Lab Package'}`}
                  height={45}
                />
              )}
            </Row>
          }
        />
      </Column>
    </Column>
  )
}

export default InstitutionLabTestsPage
